import RouterConfig from "./RouterConfig"
import { RouterProvider } from "react-router-dom"

const CustomRouterProvider = ({children}) => {
   return<RouterProvider router={RouterConfig}>
      {children}
   </RouterProvider>
}

export default CustomRouterProvider